import { emitter, idb, ldb } from "@codesuma/baseline";

const db = idb('papa')

const STORE = 'list_items'
const LIST_STORE = 'lists'

// Memoized so it's safe to call from multiple places (boot, seeding) — the
// stores are only created once and every caller awaits the same promise.
let initPromise: Promise<boolean> | null = null

const init = (): Promise<boolean> => {
    if (initPromise) return initPromise
    initPromise = (async () => {
        if (!ldb.get('papa-init')) ldb.set('papa-init', true)
        let { version, stores } = await db.info()
        if (!stores.includes(STORE)) {
            await db.createStore(STORE, version + 1, {
                keyPath: 'id',
                autoIncrement: false,
                indices: [
                    'name',
                    'checked',
                    'category',
                    'user_id',
                    'synced',
                    'created_at',
                    'updated_at',
                ]
            })
            ;({ version, stores } = await db.info())
        }
        if (!stores.includes(LIST_STORE)) {
            await db.createStore(LIST_STORE, version + 1, {
                keyPath: 'id',
                autoIncrement: false,
                indices: ['name', 'created_by', 'role', 'synced', 'created_at']
            })
        }
        emitter.emit('db-ready')
        return true
    })()
    return initPromise
}

export default {
    ...db,
    init,
    STORE,
    LIST_STORE,
}